import { call, delay, fork, put, select, takeEvery } from 'redux-saga/effects';
import { error as notificationError, success } from '@innovyze/stylovyze';

import { AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { TilingJobPayload } from '@Types/tiling.types';
import { actions } from '@Reducers/tiling.reducer';
import { generateTilesForSystemType } from '@Services/assets';
import { selectIsQueueBlocked } from '@Selectors/tiling.selectors';

function* queueJobSaga(action: PayloadAction<TilingJobPayload>) {
	const isQueueBlocked: ReturnType<typeof selectIsQueueBlocked> =
		yield select(state =>
			selectIsQueueBlocked(state, action.payload.systemType),
		);
	// don't queue job if currently blocked
	if (isQueueBlocked) return;
	try {
		yield put(actions.queueJobSending(action.payload));
		const response: AxiosResponse<unknown> = yield call(
			generateTilesForSystemType,
			action.payload.systemType,
		);
		if (response.status === 200) {
			yield put(actions.queueJobSuccess(action.payload));
			yield put(success('Map refresh queued'));
			yield fork(startJobQueueTimer, action.payload);
		} else {
			yield put(actions.queueJobFailed(action.payload));
			yield put(
				notificationError(
					'Map refresh failed: Server error. Wait and try again.',
				),
			);
		}
	} catch (error) {
		yield put(actions.queueJobFailed(action.payload));
		yield put(
			notificationError(
				'Map refresh failed: Server error. Wait and try again.',
			),
		);
	}
}

function* startJobQueueTimer(payload: TilingJobPayload) {
	yield delay(30000);
	yield put(actions.queueFreed(payload));
}

function* watchQueueJob() {
	yield takeEvery(actions.queueJob.toString(), queueJobSaga);
}

export default [watchQueueJob()];
